import { v4 } from 'uuid'

const portuguesPlan = [
  {
    id: v4(),
    pathology: {
      id: '56717001',
      name: 'Tuberculose',
      displayKey: 'tuberculosis'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '66071002',
      name: 'Hepatite B',
      displayKey: 'hepatitis_b'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 0,
        unit: 'day'
      },
      {
        sequenceNumber: 2,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '709410003',
      name: 'Hib',
      displayKey: 'hib'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 18,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '397428000',
      name: 'Difteria',
      displayKey: 'diphtheria'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 18,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '76902006',
      name: 'Tétano',
      displayKey: 'tetanus'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 18,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      },
      {
        sequenceNumber: 6,
        val: 10,
        unit: 'year'
      },
      {
        sequenceNumber: 7,
        val: 25,
        unit: 'year'
      },
      {
        sequenceNumber: 8,
        val: 45,
        unit: 'year'
      },
      {
        sequenceNumber: 9,
        val: 65,
        unit: 'year'
      },
      {
        sequenceNumber: 10,
        val: 75,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '27836007',
      name: 'Tosse Convulsa',
      displayKey: 'pertussis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 18,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '398102009',
      name: 'Poliomielite',
      displayKey: 'poliomyelitis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 18,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '9861002',
      name: 'Doença Pneumocócica',
      displayKey: 'pneumococcal_disease'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 12,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '23511006',
      name: 'Doença Meningocócica C',
      displayKey: 'meningococcal_infection'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '14189004',
      name: 'Sarampo',
      displayKey: 'measles'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '240526004',
      name: 'Parotidite Epidémica',
      displayKey: 'mumps'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '36653000',
      name: 'Rubéola',
      displayKey: 'rubella'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '371973000',
      name: 'Cancro Colo do Útero',
      displayKey: 'uterine_cancer'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 10,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '52947006',
      name: 'Encefalite Japonesa',
      displayKey: 'japanese_encephalitis'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '63650001',
      name: 'Cólera',
      displayKey: 'cholera'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '16541001',
      name: 'Febre Amarela',
      displayKey: 'yellow_fever'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '4834000',
      name: 'Febre Tifóide',
      displayKey: 'typhoid_fever'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '40468003',
      name: 'Hepatite A',
      displayKey: 'hepatitis_a'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '14168008',
      name: 'Raiva',
      displayKey: 'rabies'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '64694002',
      name: 'Rotavirus',
      displayKey: 'rotavirus'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '38907003',
      name: 'Varicela',
      displayKey: 'varicella'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '6142004',
      name: 'Gripe Sazonal',
      displayKey: 'influenza'
    },
    entries: []
  }
]

const brasilianPlan = [
  {
    id: v4(),
    pathology: {
      id: '56717001',
      name: 'Tuberculose',
      displayKey: 'tuberculosis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 0,
        unit: 'day'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '66071002',
      name: 'Hepatite B',
      displayKey: 'hepatitis_b'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 0,
        unit: 'day'
      },
      {
        sequenceNumber: 2,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 6,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '709410003',
      name: 'Hib',
      displayKey: 'hib'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '397428000',
      name: 'Difteria',
      displayKey: 'diphtheria'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 15,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 4,
        unit: 'year'
      },
      {
        sequenceNumber: 6,
        val: 10,
        unit: 'year'
      },
      {
        sequenceNumber: 7,
        val: 20,
        unit: 'year'
      },
      {
        sequenceNumber: 8,
        val: 30,
        unit: 'year'
      },
      {
        sequenceNumber: 9,
        val: 40,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '76902006',
      name: 'Tétano',
      displayKey: 'tetanus'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 15,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 4,
        unit: 'year'
      },
      {
        sequenceNumber: 6,
        val: 10,
        unit: 'year'
      },
      {
        sequenceNumber: 7,
        val: 20,
        unit: 'year'
      },
      {
        sequenceNumber: 8,
        val: 30,
        unit: 'year'
      },
      {
        sequenceNumber: 9,
        val: 40,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '27836007',
      name: 'Tosse Convulsa',
      displayKey: 'pertussis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 15,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 4,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '398102009',
      name: 'Poliomielite',
      displayKey: 'poliomyelitis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 6,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 15,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 4,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '9861002',
      name: 'Doença Pneumocócica',
      displayKey: 'pneumococcal_disease'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 12,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 5,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '64694002',
      name: 'Rotavirus',
      displayKey: 'rotavirus'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '23511006',
      name: 'Doença Meningocócica C',
      displayKey: 'meningococcal_infection'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 5,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 12,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '16541001',
      name: 'Febre Amarela',
      displayKey: 'yellow_fever'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 9,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '40468003',
      name: 'Hepatite A',
      displayKey: 'hepatitis_a'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '14189004',
      name: 'Sarampo',
      displayKey: 'measles'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '240526004',
      name: 'Parotidite Epidémica',
      displayKey: 'mumps'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '36653000',
      name: 'Rubéola',
      displayKey: 'rubella'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 12,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '38907003',
      name: 'Varicela',
      displayKey: 'varicella'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 15,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 4,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '371973000',
      name: 'Cancro Colo do Útero',
      displayKey: 'uterine_cancer'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 9,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '52947006',
      name: 'Encefalite Japonesa',
      displayKey: 'japanese_encephalitis'
    },
    entries: []
  }
]

const germanPlan = [
  {
    id: v4(),
    pathology: {
      id: '76902006',
      name: 'Tetanus',
      displayKey: 'tetanus'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 11,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      },
      {
        sequenceNumber: 6,
        val: 9,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '397428000',
      name: 'Difteria',
      displayKey: 'diphtheria'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 11,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      },
      {
        sequenceNumber: 6,
        val: 9,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '27836007',
      name: 'Tosse Convulsa',
      displayKey: 'pertussis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 11,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 5,
        unit: 'year'
      },
      {
        sequenceNumber: 6,
        val: 9,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '709410003',
      name: 'Hib',
      displayKey: 'hib'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 11,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '398102009',
      name: 'Poliomielite',
      displayKey: 'poliomyelitis'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 11,
        unit: 'month'
      },
      {
        sequenceNumber: 5,
        val: 9,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '66071002',
      name: 'Hepatite B',
      displayKey: 'hepatitis_b'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 3,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 11,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '9861002',
      name: 'Doença Pneumocócica',
      displayKey: 'pneumococcal_disease'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 2,
        val: 4,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 11,
        unit: 'month'
      },
      {
        sequenceNumber: 4,
        val: 60,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '18624000',
      name: 'Rotavirus',
      displayKey: 'rotavirus'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 6,
        unit: 'week'
      },
      {
        sequenceNumber: 2,
        val: 2,
        unit: 'month'
      },
      {
        sequenceNumber: 3,
        val: 4,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '23511006',
      name: 'Meningococcal C',
      displayKey: 'meningococcal_infection'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '14189004',
      name: 'Measles',
      displayKey: 'measles'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 11,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '240526004',
      name: 'Parotidite Epidémica',
      displayKey: 'mumps'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 11,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '36653000',
      name: 'Rubella',
      displayKey: 'rubella'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 11,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '38907003',
      name: 'Varicella',
      displayKey: 'varicella'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 11,
        unit: 'month'
      }, {
        sequenceNumber: 2,
        val: 15,
        unit: 'month'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '371973000',
      name: 'Uterine Cancer',
      displayKey: 'uterine_cancer'
    },
    entries: [
      {
        sequenceNumber: 2,
        val: 9,
        unit: 'year'
      }
    ]
  },
  {
    id: v4(),
    pathology: {
      id: '52947006',
      name: 'Encefalite Japonesa',
      displayKey: 'japanese_encephalitis'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '63650001',
      name: 'Cólera',
      displayKey: 'cholera'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '16541001',
      name: 'Febre Amarela',
      displayKey: 'yellow_fever'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '4834000',
      name: 'Febre Tifóide',
      displayKey: 'typhoid_fever'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '40468003',
      name: 'Hepatite A',
      displayKey: 'hepatitis_a'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '14168008',
      name: 'Raiva',
      displayKey: 'rabies'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '64694002',
      name: 'Rotavirus',
      displayKey: 'rotavirus'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '38907003',
      name: 'Varicela',
      displayKey: 'varicella'
    },
    entries: []
  },
  {
    id: v4(),
    pathology: {
      id: '6142004',
      name: 'Gripe Sazonal',
      displayKey: 'influenza'
    },
    entries: [
      {
        sequenceNumber: 1,
        val: 60,
        unit: 'year'
      }
    ]
  }
]

const portuguesVersion = {
  id: v4(),
  protocolEntries: portuguesPlan,
  metadata: {}
}

const germanVersion = {
  id: v4(),
  protocolEntries: germanPlan,
  metadata: {}
}

const brasilianVersion = {
  id: v4(),
  protocolEntries: brasilianPlan,
  metadata: {}
}

export { portuguesVersion, germanVersion, brasilianVersion }

export default {
  id: v4(),
  protocolEntries: portuguesPlan,
  metadata: {}
}
